import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FlexContainer } from "../../../constants/assets/containers";
import FilterSearchBar from "../Filters";
import DisputesListTable from "../DisputesListTable";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DisputesActions from "../../../store/actions/Disputes";
import ListPagination from "../../Common/ListPagination";
import { isMobile } from "../../../utils";

const DisputesList = ({
  list,
  applyFilters,
  clearFilters,
  getDisputesList,
  nextPage,
  prevPage,
  allFilters,
  filters,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  //handle pagination
  const handleNavClick = (action) => {
    let filters = { ...allFilters };
    if (action === "prev") {
      filters["page"] = currentPage - 1;
      setCurrentPage(currentPage - 1);
      getDisputesList(filters);
    } else {
      filters["page"] = currentPage + 1;
      setCurrentPage(currentPage + 1);
      getDisputesList(filters);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(allFilters)]);

  useEffect(() => {
    if (filters.page !== currentPage) {
      setCurrentPage(filters.page);
    }
  }, []);

  return (
    <PartnerListContainer align="flex-start">
      <LeftSection>
        <FilterSearchBar
          applyFilters={applyFilters}
          clearFilters={clearFilters}
        />
      </LeftSection>
      <RightSection>
        <DisputesListTable list={list} />
        <ListPagination
          nextPage={nextPage}
          prevPage={prevPage}
          handleNavClick={handleNavClick}
        />
      </RightSection>
    </PartnerListContainer>
  );
};

const PartnerListContainer = styled(FlexContainer)`
  flex-direction: ${isMobile() ? "column" : "row"};
  align-items: ${isMobile() ? "inherit" : "flex-start"};
`;

const LeftSection = styled.div`
  flex: 0 1 30%;
  margin-bottom: ${isMobile() ? "20px" : "unset"};
`;

const RightSection = styled.div`
  flex: 0 1 70%;
  height: calc(100vh - 200px);
  width: 100%;
`;

function mapStateToProps(state) {
  const { Disputes } = state;
  return {
    filters: Disputes.Filters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDisputesList: bindActionCreators(
      DisputesActions.getDisputesList,
      dispatch
    ),
    resetState: bindActionCreators(DisputesActions.resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DisputesList);
